import { useState, useEffect } from "react";
import { Category } from "src/shared/services/interfacev2";
import { getCategory } from "src/shared/services/servicesv2";

export const useRestaurantData = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchCategories = async () => {
    try {
      const res = await getCategory()
      setCategories(res.data.categoryDetails);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchCategories(),]).finally(() => setLoading(false));
  }, []);

  return { categories, loading, refetchCategories: fetchCategories, };
};